import { render, staticRenderFns } from "./AudioRoomParticipants.vue?vue&type=template&id=bd97db54&scoped=true&"
import script from "./AudioRoomParticipants.vue?vue&type=script&lang=js&"
export * from "./AudioRoomParticipants.vue?vue&type=script&lang=js&"
import style0 from "./AudioRoomParticipants.vue?vue&type=style&index=0&id=bd97db54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd97db54",
  null
  
)

export default component.exports